$(document).ready(function(){
  $('form#credit_points_certification input#consent').on('change', function(){
    $('form#credit_points_certification input.button').attr("disabled", !$(this).is(":checked"));
  })
})